import React from "react";
import Http from "../../utils/http";
import { Toast, Modal } from "antd-mobile";
import * as Api from "../../utils/api";

import "swiper/dist/css/swiper.min.css";

import Loading from "../../components/Loading";
import HomeCourseList from "../../components/home/HomeCourseList";
import FamousDoctor from "../../components/FamousDoctor";
import FixBottomBtn from "../../components/FixBottomBtn";
import Utils from "../../utils/utils";

let topBgImage = require("../../assets/images/bg_list_top.png");
let topTitleImage = require("../../assets/images/bg_list_title.png");
let topInsImage = require("../../assets/images/bg_ist_describe.png");
let topNavBgImage = require("../../assets/images/top_nav_bg.png");
const GLOBAL_IMAGE_URL = Api.imageGlobalUrl;
const alert = Modal.alert;
const HttpInstance = new Http();
const utils = new Utils();
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isBindPhone: false,
      showTopNav: false,
      styleData: {},
      recommendCourseList: [],
      hotCourseList: [],
      freeCourseList: [],
      introduction:
        "\r\n腹部临床症状分析不清？\r\n\r\n疑难疾病诊断鉴别犹豫不决？\r\n\r\n经常苦恼于理论与实际联系不上？\r\n\r\n......\r\n\r\n不管你是影像小白还是具有一定临床经验的实战医师\r\n\r\n在腹部影像学习的过程中你一定多少会遇到过以上类似的问题\r\n\r\n其实之所以会出现这样的情况，往往是在于自己的腹部基础不够扎实和诊断思维搭建不够牢固造成的；\r\n\r\n如果我说山西医科大学第一医院的“首席专家”亲自来为大家传授腹部影像知识，从入门到精通，带你轻松攻破腹部影像，你感不感兴趣呢？\r\n\r\n没错，放射沙龙这次特别邀请到了山西医科大学第一医院放射科主任、副院长，山西医科大学医学影像系主任——李健丁教授，亲建腹部影像精品视频课程；\r\n\r\n课程学习中李教授将“面对面”为大家分享40多年的腹部影像实战经验，从解剖、影像、病理、鉴别全方位讲解腹部影像知识，从0到1帮助万千的影像医生实现学习进阶；\r\n\r\n这是一个实属难得的机会，这也是李教授多年的从医历程影显，相信你在这门课程中一定会有所收获！\r\n\r\n",
      currentTab: 0,
      showFixButton: true,
      AppConfig: {
        scheme: "fssl",
        package: "com.fssl.salon",
        action: "android.intent.action.VIEW",
        category: "android.intent.category.BROWSABLE",
        host: "https://sj.qq.com",
        FAILBACK_ANDROID:
          "https://sj.qq.com/myapp/detail.htm?apkName=com.yiban.salon",
        FAILBACK_IOS:
          "https://sj.qq.com/myapp/detail.htm?apkName=com.yiban.salon",
      },
    };
  }
  render() {
    const _this = this;
    return (
      <div>
        {_this.state.isLoading ? (
          <Loading></Loading>
        ) : (
          <div
            className="homeContainer"
            style={{
              backgroundColor:
                _this.state.styleData.backgroundColor || "#40188F",
            }}
          >
            <div
              className="topbg-container"
              style={{
                backgroundImage: `url(${topBgImage})`,
              }}
            >
              <div className="top-title">
                <img src={topTitleImage} />
              </div>
            </div>
            {/* 新课推荐 */}
            <HomeCourseList
              type="recommend"
              moduleTitle={_this.state.styleData.oneTitlePic}
              courseList={_this.state.recommendCourseList}
              courseDetailHandler={_this.courseDetail.bind(_this)}
            ></HomeCourseList>
            {/* 热门课程 */}
            <HomeCourseList
              type="hot"
              moduleTitle={_this.state.styleData.twoTitlePic}
              courseList={_this.state.hotCourseList}
              courseDetailHandler={_this.courseDetail.bind(_this)}
            ></HomeCourseList>
            {/* 免费课程 */}
            <HomeCourseList
              type="free"
              moduleTitle={_this.state.styleData.threeTitlePic}
              courseList={_this.state.freeCourseList}
              courseDetailHandler={_this.courseDetail.bind(_this)}
            ></HomeCourseList>
            {/* 入驻名医 */}
            <FamousDoctor></FamousDoctor>
            <FixBottomBtn
              downLoadHandler={_this.downLoadHandler.bind(_this)}
              myCourceHandler={_this.myCourceHandler.bind(_this)}
              showFixButton={_this.state.showFixButton}
              showTopNav={_this.state.showTopNav}
            ></FixBottomBtn>
          </div>
        )}
      </div>
    );
  }
  componentWillMount() {
    const _this = this;
    /**
     * 判断是否App内打开*/
    let isApp = HttpInstance.getSearchByName(
      this.props.location.search,
      "isApp"
    );
    if (isApp) {
      _this.setState({
        showFixButton: false,
      });
    } else {
      _this.toLogin();
      // let loginParams = {}
      // loginParams.accessToken = 'fs82cd6181bf1c33a619149c2070b8a2cc';
      // loginParams.openID = 'o7Lvz0q9a5DTthqm81L0oAVT9y8E';
      // loginParams.unionid = 'oyrgy1QwMQNS-WpGxHKtY3UoeqsE';
      // loginParams.userID = '1168402';
      // loginParams = JSON.stringify(loginParams);
      // localStorage.setItem("loginData", loginParams);
      // _this.queryPageInfo();
    }
  }
  componentDidMount() {
    const _this = this;
    document.title = "放射沙龙";
    window.scrollTo(0, 0);

    // 判断是否是app
    let isApp = HttpInstance.getSearchByName(
      this.props.location.search,
      "isApp"
    );
    console.log("是不是app", isApp);
    if (!isApp) {
      utils.wxShareConfig(_this, isApp);
    }
  }
  toLogin() {
    const _this = this;
    let linkUrl = window.location.href;
    let code = HttpInstance.UrlSearchCode(linkUrl);
    if (code && code != "") {
      //根据code去获取openId
      _this.getOpenId(code);
    } else {
      _this.queryPageInfo();
    }
  }
  getCode() {
    var locationUrl = encodeURIComponent(Api.AUTH_GLOBAL_URL);
    window.location.href =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdcac93666607fff5&redirect_uri=" +
      locationUrl +
      "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
  }
  getOpenId(code) {
    const _this = this;
    let liveCode = localStorage.getItem("code");
    if (liveCode && liveCode !== "") {
      if (liveCode == code) {
        _this.queryPageInfo();
      } else {
        localStorage.setItem("code", code);
        _this.loginByCode(code);
      }
    } else {
      localStorage.setItem("code", code);
      _this.loginByCode(code);
    }
  }
  loginByCode(code) {
    const _this = this;
    let params = {};
    params.wxCode = code;
    let response = HttpInstance.login(Api.QUERY_ACCESSTOKEN_API, params);
    response.then((data) => {
      let responseData = data.data;
      if (responseData.result) {
        let loginParams = {};
        loginParams.accessToken = responseData.data["accessToken"];
        loginParams.openID = responseData.data["openID"];
        loginParams.unionid = responseData.data["unionid"];
        loginParams.userID = responseData.data["userID"];
        loginParams = JSON.stringify(loginParams);
        localStorage.setItem("loginData", loginParams);
        let loginTime = new Date().getTime();
        localStorage.setItem("loginTime", loginTime);
        _this.queryPageInfo();
      }
    });
  }
  /**
   * 获取页面信息
   * */
  queryPageInfo() {
    const _this = this;
    _this.queryFreeCourse();
  }
  /*
   * 获取免费课程
   */
  queryFreeCourse() {
    const _this = this;
    let params = {};
    params.pageIndex = 1;
    params.pageSize = 3;
    let response = HttpInstance.post(Api.QUERY_FREECOURSE_API, params);
    response.then((data) => {
      let responseData = data.data;
      _this.setState(
        {
          freeCourseList: responseData.data || [],
        },
        () => {
          _this.queryRecommendCourse();
        }
      );
    });
  }
  /*
   * 获取推荐课程
   */
  queryRecommendCourse() {
    const _this = this;
    let params = {};
    let response = HttpInstance.post(Api.QUERY_RECOMMENDCOURSE_API, params);
    response.then((data) => {
      let response = data.data;
      let responseData = response.data;
      _this.setState(
        {
          recommendCourseList: responseData.recommendCourseList || [],
          hotCourseList: responseData.hotCourseList || [],
          styleData: responseData.gzhBg,
          isLoading: false,
        },
        () => {
          Toast.hide();
        }
      );
    });
  }
  getAndroidSchema() {
    const _this = this;
    var Navigator = navigator.userAgent;
    var ifChrome =
      Navigator.match(/Chrome/i) != null &&
      Navigator.match(/Version\/\d+\.\d+(\.\d+)?\sChrome\//i) == null
        ? true
        : false;
    var AppConfig = _this.state.AppConfig;
    var schemaStr = "www.xxx.com/open?a=test";
    if (ifChrome) {
      schemaStr =
        "intent://" +
        schemaStr +
        "#Intent;" +
        "scheme=" +
        AppConfig.scheme +
        ";" +
        "package=" +
        AppConfig.package +
        ";" +
        "category=" +
        AppConfig.category +
        ";" +
        "S.browser_fallback_url=" +
        encodeURIComponent(AppConfig.FAILBACK_ANDROID) +
        ";" +
        "end";
    } else {
      schemaStr = "xxx://www.xxx.com/open";
    }
    return schemaStr;
  }
  downLoadHandler() {
    const _this = this;
    var AppConfig = _this.state.AppConfig;
    // 判断浏览器
    var Navigator = navigator.userAgent;
    var ifChrome =
      Navigator.match(/Chrome/i) != null &&
      Navigator.match(/Version\/\d+\.\d+(\.\d+)?\sChrome\//i) == null
        ? true
        : false;
    var ifAndroid = Navigator.match(/(Android);?[\s\/]+([\d.]+)?/)
      ? true
      : false;
    var ifiPad = Navigator.match(/(iPad).*OS\s([\d_]+)/) ? true : false;
    var ifiPhone =
      !ifiPad && Navigator.match(/(iPhone\sOS)\s([\d_]+)/) ? true : false;
    var ifSafari = (ifiPhone || ifiPad) && Navigator.match(/Safari/);
    var version = 0;
    ifSafari && (version = Navigator.match(/Version\/([\d\.]+)/));
    // safari浏览器版本
    version = parseFloat(version[1], 10);
    // 是否从微信打开
    var ifWeixin = navigator.userAgent.indexOf("MicroMessenger") >= 0; // weixin
    // 由安卓APP提供
    // android打开app 地址
    if (ifAndroid) {
      var s = _this.getAndroidSchema();
      if (ifChrome) {
        // chrome会自动识别S.browser_fallback_url如果没有安装则打开下载链接地址
        window.location.href = s;
      } else if (ifWeixin) {
        // 微信无法打开APP，跳转到下载页面
        window.location.href = AppConfig.FAILBACK_ANDROID;
      } else {
        // 其他浏览器3秒内没打开则跳转到下载链接
        window.location.href = s;
        var start = Date.now();
        // 如果页面在后台运行返回，如果超过3秒没有打开APP，则没有安装，跳转到应用市场
        loadTimer = setTimeout(function () {
          if (document.hidden || document.webkitHidden) {
            return;
          }
          if (Date.now() - start <= 3000 + 200) {
            window.location.href = AppConfig.FAILBACK_ANDROID;
          } else {
          }
        }, 3000);
      }
    }

    if (ifiPhone) {
      var openUrl = "fssl://";
      var universalUrl =
        "https://sj.qq.com/myapp/detail.htm?apkName=com.yiban.salon";

      if (ifWeixin) {
        // 微信
        window.location.href = universalUrl;
        return;
      }
      if (ifSafari && version >= 9) {
        // 判断IOS版本 如果大于9
        setTimeout(function () {
          // 必须要使用settimeout
          var ar = document.createElement("a");
          ar.setAttribute("href", openUrl);
          ar.style.display = "none";
          document.body.appendChild(ar);
          var av = document.createEvent("HTMLEvents");
          av.initEvent("click", !1, !1);
          ar.dispatchEvent(av);
        }, 0);
      } else {
        window.location.href = openUrl;
      }
      // 如果页面在后台运行返回，如果超过3秒没有打开APP，则没有安装，跳转到IOS应用市场
      var loadTimer = setTimeout(function () {
        if (document.hidden || document.webkitHidden) {
          return;
        }
        if (Date.now() - start > 3000 + 200) {
        } else {
          window.location.href = AppConfig.FAILBACK_IOS;
        }
      }, 3000);
    }

    // 当页面在后台运行时清空定时器防止页面跳转到下载页
    var visibilitychange = function () {
      var tag = document.hidden || document.webkitHidden;
      tag && clearTimeout(loadTimer);
    };
    document.addEventListener("visibilitychange", visibilitychange, false);
    document.addEventListener(
      "webkitvisibilitychange",
      visibilitychange,
      false
    );
    window.addEventListener(
      "pagehide",
      function () {
        clearTimeout(loadTimer);
      },
      false
    );
  }
  /**
   * 课程详情
   * */
  courseDetail(item) {
    const _this = this;
    let loginData = localStorage.getItem("loginData");
    if (_this.state.showFixButton == false) {
      var params = {};
      params.courseID = item.courseID;
      params.type = "html";
      window.postMessage(JSON.stringify(params));
    } else {
      if (loginData) {
        _this.props.history.push({
          pathname: "/play",
          search: "?courseID=" + item.courseID,
        });
      } else {
        _this.wxAuth();
      }
    }
  }
  wxAuth() {
    alert("微信授权", "请先进行微信授权", [
      {
        text: "取消",
        onPress: () => {},
      },
      {
        text: "授权",
        onPress: () => {
          var locationUrl = encodeURIComponent(Api.AUTH_GLOBAL_URL);
          window.location.replace(
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdcac93666607fff5&redirect_uri=" +
              locationUrl +
              "&response_type=code&scope=snsapi_userinfo#wechat_redirect"
          );
        },
      },
    ]);
  }
  /**
   * 联系我们 */
  contactUs() {
    const _this = this;
    alert("拨打客服电话", "0755—22287302 转 8050", [
      {
        text: "取消",
        onPress: () => {},
      },
      {
        text: "继续呼叫",
        onPress: () => {
          window.location.href = "tel:0755—22287302";
        },
      },
    ]);
  }
  /**
   * [myCource 我的课程]
   * @author zhangzhaohui
   * @DateTime 2020-04-30T09:50:03+0800
   * @return   {[type]}                 [description]
   */
  myCourceHandler() {
    const _this = this;
    let loginData = localStorage.getItem("loginData");
    if (loginData) {
      let params = {};
      if (loginData) {
        loginData = JSON.parse(loginData);
        params.openId = loginData.openID;
        params.unionid = loginData.unionid;
        let response = HttpInstance.postJSON(Api.QUERY_PHONEBIND_API, params);
        response.then((data) => {
          let responseData = data.data;
          if (responseData.result) {
            _this.props.history.push({ pathname: "/cource" });
          } else {
            _this.props.history.push({ pathname: "/bind" });
          }
        });
      }
    } else {
      _this.wxAuth();
    }
  }
}
let uiTopbgStyle = {
  backgroundImage: `url(${topBgImage})`,
};
let uiTopInsStyle = {
  backgroundImage: `url(${topInsImage})`,
};
let uiTopNavStyle = {
  backgroundImage: `url(${topNavBgImage})`,
};
